// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3joIC","col":"styles_col__1VKz3","actions":"styles_actions__1smMw","conflict":"styles_conflict__1HRI1"};